import * as yup from 'yup';
import _get from 'lodash/get';
import { RenderConfig, Row, SelectInput, NumberInput } from 'commons-ui';

import { FORM_FIELD_KEYS, REWARD_TYPE_OPTIONS } from '../constants';
import { EWinningCreditType } from '../kindReward.model';

export const validationSchema = yup.object().shape({
	tournamentID: yup
		.string()
		.test('len', 'tournament ID length should be longer!', (val) => !val || val.length > 1)
		.optional(),
	userId: yup
		.string()
		.test('len', 'User ID length should be longer!', (val) => !val || val.length > 1)
		.optional()
});

export const FORM_FIELD_CONFIG: {
	[x: string]: RenderConfig;
} = {
	[FORM_FIELD_KEYS.TOURNAMENT_ID]: new RenderConfig()
		.setName('tournamentID')
		.setLabel('Tournament ID')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.USER_ID]: new RenderConfig()
		.setName('userId')
		.setLabel('User ID')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		})
};

const buyingPriceDependencyResolver = (
	props: any,
	dependencyValues: { '0': EWinningCreditType }
): {
	disabled: boolean;
} | null => {
	const requestStatus: EWinningCreditType = _get(dependencyValues, '0');
	if (requestStatus === EWinningCreditType.CASH) {
		return { disabled: true };
	}
	if (requestStatus === EWinningCreditType.KIND) {
		return { disabled: false };
	}
	return null;
};

export const FORM_LAYOUT_CONFIG: Row[] = [new Row(FORM_FIELD_KEYS.TOURNAMENT_ID), new Row(FORM_FIELD_KEYS.USER_ID)];

export const CREDIT_FORM_FIELD_CONFIG: {
	[x: string]: RenderConfig;
} = {
	[FORM_FIELD_KEYS.CREDIT_TYPE]: new RenderConfig()
		.setName('creditType')
		.setLabel('Credit Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: REWARD_TYPE_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.BUYING_PRICE]: new RenderConfig()
		.setName('buyingPrice')
		.setLabel('Buying Price')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			dependencies: ['creditType'],
			required: true,
			dependencyResolver: buyingPriceDependencyResolver
		})
};

export const CREDIT_FORM_LAYOUT_CONFIG: Row[] = [new Row(FORM_FIELD_KEYS.CREDIT_TYPE), new Row(FORM_FIELD_KEYS.BUYING_PRICE)];
